export const formName = 'meal-registration';

export const defaultAmount = 4;
